import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { 
  ExitToApp as SignOutIcon,
  Person as ProfileIcon,
  ExpandMore as ArrowIcon
} from '@mui/icons-material';
import '../styles/UserDropdown.css';

const UserDropdown = () => {
  const { user, signOut } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Helper function to get user initial
  const getUserInitial = () => {
    if (user?.firstName && user.firstName.length > 0) {
      return user.firstName[0].toUpperCase();
    }
    if (user?.email && user.email.length > 0) {
      return user.email[0].toUpperCase();
    }
    return 'U';
  };

  // Get display name
  const getDisplayName = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName} ${user.lastName}`;
    }
    return user?.email || 'User';
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle sign out
  const handleSignOut = async () => {
    try {
      setIsOpen(false);
      await signOut();
      // Redirect will be handled by the AuthContext
    } catch (error) {
      console.error('Failed to sign out:', error);
    }
  };

  return (
    <div className="user-dropdown" ref={dropdownRef}>
      <div 
        className="user-info" 
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && setIsOpen(!isOpen)}
      >
        <div className="user-avatar">{getUserInitial()}</div>
        <span className="user-name">{getDisplayName()}</span>
        <ArrowIcon className={`user-dropdown-arrow ${isOpen ? 'open' : ''}`} />
      </div>

      {isOpen && (
        <div className="user-dropdown-menu">
          <div className="dropdown-header">
            <div className="dropdown-user-info">
              <div className="dropdown-user-avatar">{getUserInitial()}</div>
              <div className="dropdown-user-details">
                <div className="dropdown-user-name">{getDisplayName()}</div>
                <div className="dropdown-user-email">{user?.email}</div>
                <div className="dropdown-user-role">
                  {user?.role === 'team_member' ? 'Team Member' : 
                   user?.role?.charAt(0).toUpperCase() + user?.role?.slice(1)}
                </div>
              </div>
            </div>
          </div>
          
          <div className="dropdown-divider"></div>
          
          <div className="dropdown-options">
            <button 
              className="dropdown-option"
              onClick={handleSignOut}
            >
              <SignOutIcon className="dropdown-option-icon" />
              Sign Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDropdown; 